import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Icon } from 'components'

import './label.scss'

const Label = ({ text, theme, icon, onRemove }) => {
	const componentClass = 'o-label'
	const cssClasses = classNames(
		componentClass,
		theme && `${componentClass}--theme-${theme}`,
		icon && `${componentClass}--has-icon`,
		onRemove && `${componentClass}--has-button`
	)

	return (
		<span className={cssClasses}>
			{icon && <span className={`${componentClass}__icon`}>{icon}</span>}
			{text}
			{onRemove && (
				<button
					className={`${componentClass}__button`}
					onClick={onRemove}
					onKeyPress={onRemove}
					type="button"
				>
					<Icon name="close" fitToParent />
				</button>
			)}
		</span>
	)
}

Label.propTypes = {
	text: PropTypes.string.isRequired,
	theme: PropTypes.oneOf([
		'default',
		'important',
		'success',
		'warning',
		'error',
	]),
	icon: PropTypes.node,
	onRemove: PropTypes.func,
}

Label.defaultProps = {
	theme: 'default',
	icon: null,
	onRemove: null,
}

export default Label
